<template>
  <main>
    <div class="container">
      <div class="main-wrapper">
        <div class="collections-container">
          <div class="preloader" v-if="items.length == 0">
            <b-spinner
              variant="primary"
              type="grow"
              label="Spinning"
            ></b-spinner>
          </div>
          <h1 class="main-title"><p>Коллекции</p></h1>
          <a
            v-for="item in items"
            v-bind:key="item.id"
            v-bind:data-title="item.name"
            class="collections-link"
            @click="registration(item.id, item.name)"
            v-bind:style="{ backgroundImage: 'url(' + item.picture + ')' }"
          >
          </a>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: () => ({
    items: [],
  }),
  methods: {
    registration(id, name) {
      // Если не включен режим просмотра коллекции, переход на страницу регистрации презентации
      if(!this.$localStorageGet('viewCollection')){
        let collectionInfo = {
          collectionName: name,
          collectionID: id,
        };
        this.$localStorageSet("RegistrationCollectionInfo", collectionInfo);
        this.$router.push({ name: "PresentationRegistr" });
      }else{
        this.$router.push('/catalog/'+id);
      }
      
    }
  },
  created() {

    this.$store
      .dispatch("GET_COLLECTION_LIST")
      .then((data) => {
        this.items = data;
      })
      .catch((err) => console.log(err));
  },
};
</script>
<style lang="scss" scoped>
.collections-container {
  width: 100%;
  .collections-link {
    display: flex;
    background-size: cover;
  }
}
</style>